import { AbstractFreewheelRequestFactory } from 'tag/ts/tag/ads/freewheel/factories/AbstractFreewheelRequestFactory';
import { FreewheelDaiSdkRequest } from 'tag/ts/tag/ads/freewheel/requests/FreewheelDaiSdkRequest';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';

/**
 * @copyright © Paramount Streaming
 * @author  Zeeshan Ahmad
 * @description Used to create Freewheel DAI SDK request
 */
export class FreewheelDaiSdkRequestFactory extends AbstractFreewheelRequestFactory {

	constructor( argument: ITagAbstractClassArgument ) {
		super(
			{
				...argument,
				name: 'FreewheelDaiSdkRequestFactory'
			}
		);
	}

	/**
	 * @description Creates and returns a FreewheelDaiSdkRequest instance
	 * @return {FreewheelDaiSdkRequest}
	 */
	createRequest(): FreewheelDaiSdkRequest {
		const request = new FreewheelDaiSdkRequest( { tag: this.tag } );
		this?.logger?.log( 'createRequest', 'returning FreewheelDaiSdkRequest:', request );
		return request;
	}
}